import { useState } from "react";
import { GALLERY } from "@/data/site";
import { FadeUp } from "@/components/FadeUp";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { X } from "lucide-react";

export default function Gallery() {
  const [active, setActive] = useState(null);
  return (
    <div data-testid="gallery-page" className="section-y">
      <div className="container-x">
        <FadeUp>
          <p className="eyebrow">Workshop & Projects</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary mt-4 leading-[0.95] max-w-4xl">
            From the <span className="italic text-secondary">floor</span>.
          </h1>
          <p className="mt-6 text-muted-foreground max-w-xl text-lg">
            A look at the machines, parts and finished work moving through MIM Engineering.
            Real project photography will replace these placeholders shortly.
          </p>
        </FadeUp>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-testid="gallery-grid">
          {GALLERY.map((src, i) => (
            <FadeUp key={src + i} delay={(i % 8) * 0.05}>
              <button
                onClick={() => setActive(src)}
                data-testid="gallery-item"
                className="block w-full aspect-square overflow-hidden image-hover"
              >
                <img src={src} alt={`MIM Engineering workshop ${i + 1}`} className="w-full h-full object-cover" />
              </button>
            </FadeUp>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-5xl w-[92vw] p-0 bg-black border-0">
          <VisuallyHidden.Root>
            <DialogTitle>Gallery image preview</DialogTitle>
          </VisuallyHidden.Root>
          <button
            onClick={() => setActive(null)}
            className="absolute top-3 right-3 z-10 text-white/80 hover:text-white p-2"
            aria-label="Close"
          >
            <X size={22} />
          </button>
          {active && <img src={active} alt="Enlarged" className="w-full h-auto max-h-[88vh] object-contain" />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
